import { Component } from '@angular/core';
import { StoreService } from '@app/shared/services/store.service';

@Component({
    selector: 'app-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent {
    constructor( public store: StoreService) { }
}
